import React, { useEffect, useState } from 'react';
// material-ui
import { Button, Col, Flex, Form, Input, Row, Select, Tabs } from 'antd';
import { useGetCompanyAllMutation, useGetEmployeeListByCompanyCodeMutation, useSaveByIdMutation } from 'store/features/process/processApi';
import { toast } from 'react-toastify';
import { toastConfig } from 'config';
import COEPictureUploader from 'components/picture-upload/index';
import { useDispatch, useSelector } from 'react-redux';
import MainCard from 'components/MainCard';
import { useTheme } from '@mui/material/styles';
import { useLocation, useNavigate } from 'react-router-dom';
import { CircularProgress, Grid } from '@mui/material';
import comptroller from 'assets/images/comptroller_white.svg';
import { validateInput } from 'pages/globals/global';
import EmployeeExcelUpload from './EmployeeExcelUpload';
import EmployeeBulkUpdate from './EmployeeBulkUpdate';
import { groupBy } from 'lodash';
import useGetImage from 'hooks/useGetImage';
import { setPositionId } from 'store/features/profile/profileSlice';
import ComptrollerConfirmModal from 'pages/comptroller/ComptrollerConfirmModal';
import DetailPageHeader from 'components/header/DetailPageHeader';

const COEEmployee = () => {
	const theme = useTheme();
	const navigate = useNavigate();
	const state = useLocation();
	const [form] = Form.useForm();
	const companyCode = useSelector((state) => state?.profile?.profileData?.creatorOrganizationId);
	// const loginUserPositionCode = useSelector((state) => state?.profile?.positionId);
	const userId = useSelector((state) => state?.profile?.profileData?.userId);
	const [userInfo, setUserInfo] = useState(state?.state?.userInfo);
	const [SaveById, { data: updatedUser, isSuccess, isLoading }] = useSaveByIdMutation();
	const [existingEmployeeIdDataMap, setExistingEmployeeIdDataMap] = useState([]);
	const [fileList, setFileList] = useState([]);
	const [imageBase64, setImageBase64] = useState();
	const [positionOptions, setPositionOptions] = useState([]);
	const [positionNameMap, setPositionNameMap] = useState({});
	const [activate, setActivate] = useState(true);
	const [showModal, setShowModal] = useState(false);
	const [submitForm, setSubmitForm] = useState(false);
	const [submitExcelData, setSubmitExcelData] = useState(null);
	const [modalInfo, setModalInfo] = useState(null);
	const [submitData, setSubmitData] = useState(null);
	// const [navigateTo, setNavigateTo] = useState(null);
	const imageInfo = useGetImage(userInfo?.entityCode);

	// console.log("userInfo", userInfo);

	const [employeeTableList, setEmployeeTableList] = useState([]);
	const dispatch = useDispatch();

	const [GetEmployeeListByCompanyCode, { data: employeeList }] = useGetEmployeeListByCompanyCodeMutation();

	const [GetCompanyAll, { data: OrgStructureList }] = useGetCompanyAllMutation();

	useEffect(() => {
		GetCompanyAll({});
	}, [GetCompanyAll]);

	useEffect(() => {
		if (companyCode) {
			GetEmployeeListByCompanyCode({
				parentCode: companyCode,
			});
		} //eslint-disable-next-line
	}, [companyCode]);

	useEffect(() => {
		if (employeeList && employeeList?.length) {
			setEmployeeTableList(employeeList);
		}
	}, [employeeList]);

	const initialOptions = [
		{
			value: 'Mr.',
			label: 'Mr.',
		},
		{
			value: 'Ms.',
			label: 'Ms.',
		},
	];

	const [counter, setCounter] = useState({
		picture: 0,
		initial: 0,
		firstName: 0,
		middleName: 0,
		lastName: 0,
		email: 0,
		mobile: 0,
		designation: 0,
		band: 0,
		payGrade: 0,
		employee: 0,
		position: 0,
	});

	const { picture, initial, firstName, middleName, lastName, mobile, email, designation, band, payGrade, employee, position } = counter;

	useEffect(() => {
		if (state?.state) {
			let arr = groupBy(state?.state?.employeeTableList, 'employeeId');
			const positionCode = state?.state?.userInfo?.positionCode;
			setUserInfo({
				...state?.state?.userInfo,
				positionCode,
			});
			setExistingEmployeeIdDataMap(arr);
		} else {
			navigate('/static/employee');
		} //eslint-disable-next-line
	}, [state?.state]);

	useEffect(() => {
		if (OrgStructureList) {
			const positionOptionsArr = [];

			// add all vacant position in drop down
			OrgStructureList?.lynOrgStructModelDetailsVacant?.forEach((position) => {
				if (position?.activationStatus === 'Active') {
					positionOptionsArr.push({
						code: position.id,
						value: position.id,
						label: position.positionName,
						displayName: position.positionId,
					});
				}
			});

			setPositionNameMap(groupBy(OrgStructureList?.lynOrgStructModelDetailsAll, 'id'));

			// add current user position in drop down
			if (userInfo?.positionCode) {
				const positionOfCurrentUser = OrgStructureList?.lynOrgStructModelDetailsAll?.find((item) => item?.id === userInfo?.positionCode);
				if (positionOfCurrentUser) {
					positionOptionsArr.push({
						code: positionOfCurrentUser?.id,
						value: positionOfCurrentUser?.id,
						label: positionOfCurrentUser?.positionName,
						displayName: positionOfCurrentUser?.positionId,
					});
				}
			}

			setPositionOptions(positionOptionsArr);
		}
		//eslint-disable-next-line
	}, [OrgStructureList, userInfo?.positionCode]);

	useEffect(() => {
		if (
			picture === 1 ||
			initial === 1 ||
			firstName === 1 ||
			middleName === 1 ||
			lastName === 1 ||
			email === 1 ||
			mobile === 1 ||
			designation === 1 ||
			band === 1 ||
			payGrade === 1 ||
			employee === 1 ||
			position === 1
		) {
			setActivate(false);
		} else {
			setActivate(true);
		}
		//eslint-disable-next-line
	}, [counter]);

	useEffect(() => {
		if (updatedUser?.id && updatedUser) {
			if (userId === updatedUser?.entityCode) dispatch(setPositionId(updatedUser?.positionCode));

			toast.success('Success! Action completed.', toastConfig);

			state?.state?.tab ? navigate(`/static/employee?tab=${state?.state?.tab}`) : navigate('/static/employee');
		} else if (!updatedUser?.id && updatedUser) {
			toast.error('Failure! Action not completed.', toastConfig);
			// navigate(`/static/employee?tab=W-I-P`);
		}
		setSubmitForm(false);
		setSubmitData(null);
		//eslint-disable-next-line
	}, [updatedUser]);

	const handleActivateSubmit = (e) => {
		if (userInfo) {
			if (e.target.id === 'entityInitials') {
				let val = e.target.value;
				if (val !== userInfo?.entityInitialsG) {
					setCounter({
						...counter,
						initial: 1,
					});
				} else {
					setCounter({
						...counter,
						initial: 0,
					});
				}
			} else if (e.target.id === 'entityFirstName') {
				let val = e.target.value;
				if (val !== userInfo?.entityFirstName) {
					setCounter({
						...counter,
						firstName: 1,
					});
				} else {
					setCounter({
						...counter,
						firstName: 0,
					});
				}
			} else if (e.target.id === 'entityMiddleName') {
				let val = e.target.value;
				if (val !== userInfo?.entityMiddleName) {
					setCounter({
						...counter,
						middleName: 1,
					});
				} else {
					setCounter({
						...counter,
						middleName: 0,
					});
				}
			} else if (e.target.id === 'entityLastName') {
				let val = e.target.value;
				if (val !== userInfo?.entityLastName) {
					setCounter({
						...counter,
						lastName: 1,
					});
				} else {
					setCounter({
						...counter,
						lastName: 0,
					});
				}
			} else if (e.target.id === 'entityEmail') {
				let val = e.target.value;
				if (val !== userInfo?.entityEmail) {
					setCounter({
						...counter,
						email: 1,
					});
				} else {
					setCounter({
						...counter,
						email: 0,
					});
				}
			} else if (e.target.id === 'entityPhoneNumber') {
				let val = e.target.value;
				if (val !== userInfo?.entityPhoneNumber) {
					setCounter({
						...counter,
						mobile: 1,
					});
				} else {
					setCounter({
						...counter,
						mobile: 0,
					});
				}
			} else if (e.target.id === 'designation') {
				let val = e.target.value;
				if (val !== userInfo?.designation) {
					setCounter({
						...counter,
						designation: 1,
					});
				} else {
					setCounter({
						...counter,
						designation: 0,
					});
				}
			} else if (e.target.id === 'jobBand') {
				let val = e.target.value;
				if (val !== userInfo?.jobBand) {
					setCounter({
						...counter,
						band: 1,
					});
				} else {
					setCounter({
						...counter,
						band: 0,
					});
				}
			} else if (e.target.id === 'payGrade') {
				let val = e.target.value;
				if (val !== userInfo?.payGrade) {
					setCounter({
						...counter,
						payGrade: 1,
					});
				} else {
					setCounter({
						...counter,
						payGrade: 0,
					});
				}
			} else if (e.target.id === 'employeeId') {
				let val = e.target.value;
				if (val !== userInfo?.employeeId) {
					setCounter({
						...counter,
						employee: 1,
					});
				} else {
					setCounter({
						...counter,
						employee: 0,
					});
				}
			}
		} else {
			if (e.target.id === 'entityInitials') {
				let val = e.target.value;
				if (val !== '') {
					setCounter({
						...counter,
						initial: 1,
					});
				} else {
					setCounter({
						...counter,
						initial: 0,
					});
				}
			} else if (e.target.id === 'entityFirstName') {
				let val = e.target.value;
				if (val !== '') {
					setCounter({
						...counter,
						firstName: 1,
					});
				} else {
					setCounter({
						...counter,
						firstName: 0,
					});
				}
			} else if (e.target.id === 'entityMiddleName') {
				let val = e.target.value;
				if (val !== '') {
					setCounter({
						...counter,
						middleName: 1,
					});
				} else {
					setCounter({
						...counter,
						middleName: 0,
					});
				}
			} else if (e.target.id === 'entityLastName') {
				let val = e.target.value;
				if (val !== '') {
					setCounter({
						...counter,
						lastName: 1,
					});
				} else {
					setCounter({
						...counter,
						lastName: 0,
					});
				}
			} else if (e.target.id === 'entityEmail') {
				let val = e.target.value;
				if (val !== '') {
					setCounter({
						...counter,
						email: 1,
					});
				} else {
					setCounter({
						...counter,
						email: 0,
					});
				}
			} else if (e.target.id === 'entityPhoneNumber') {
				let val = e.target.value;
				if (val !== '') {
					setCounter({
						...counter,
						mobile: 1,
					});
				} else {
					setCounter({
						...counter,
						mobile: 0,
					});
				}
			} else if (e.target.id === 'designation') {
				let val = e.target.value;
				if (val !== '') {
					setCounter({
						...counter,
						designation: 1,
					});
				} else {
					setCounter({
						...counter,
						designation: 0,
					});
				}
			} else if (e.target.id === 'jobBand') {
				let val = e.target.value;
				if (val !== '') {
					setCounter({
						...counter,
						band: 1,
					});
				} else {
					setCounter({
						...counter,
						band: 0,
					});
				}
			} else if (e.target.id === 'payGrade') {
				let val = e.target.value;
				if (val !== '') {
					setCounter({
						...counter,
						payGrade: 1,
					});
				} else {
					setCounter({
						...counter,
						payGrade: 0,
					});
				}
			} else if (e.target.id === 'employeeId') {
				let val = e.target.value;
				if (val !== '') {
					setCounter({
						...counter,
						employee: 1,
					});
				} else {
					setCounter({
						...counter,
						employee: 0,
					});
				}
			}
		}
	};

	useEffect(() => {
		if (imageInfo?.image) {
			setImageBase64(imageInfo.image);
			setFileList(
				imageInfo?.image
					? [
							{
								uid: '-1',
								name: imageInfo.entityFullName,
								status: 'done',
								url: imageInfo.image,
							},
						]
					: []
			);
		}
	}, [imageInfo?.image]);

	useEffect(() => {
		// if (userInfo && !isEmpty(positionNameMap)) {
		if (userInfo?.entityEmail) {
			form.setFieldsValue({
				...userInfo,
				positionCode: userInfo?.positionCode ? userInfo?.positionCode : 'No Position Assign',
				designation: positionNameMap?.[userInfo?.positionCode]?.[0]?.positionName ?? 'Not Applicable',
			});
		}
	}, [userInfo, positionNameMap]);

	const onSubmit = (data) => {
		let fullName = (data?.entityFirstName ?? '') + ' ' + (data?.entityMiddleName ?? '') + ' ' + (data?.entityLastName ?? '');
		let image = imageBase64 ?? '';

		if (data?.id) {
			SaveById({
				...userInfo,
				...data,
				id: data?.id,
				entityFullName: fullName,
				entityParentCode: companyCode,
				entityCode: data?.entityEmail,
				entityStatus: userInfo?.entityStatus,
				b64PicProfile: image,
			});
		} else {
			SaveById({
				...data,
				entityFullName: fullName,
				entityParentCode: companyCode,
				entityCode: data?.entityEmail,
				b64PicProfile: image,
			});
		}
	};

	useEffect(() => {
		if (updatedUser?.code === 200) {
			toast.success('Updated Successfully.', toastConfig);
		}
	}, [updatedUser]);

	function delay(ms) {
		return new Promise((resolve) => setTimeout(resolve, ms));
	}

	const handleExcel = async (excelDataParam) => {
		for (let i = 0; i < excelDataParam.length; i++) {
			const payload = {
				id: excelDataParam[i]?.id ?? '',
				employeeId: excelDataParam[i]?.employeeId?.input ?? null,
				b64PicProfile: excelDataParam[i]?.b64PicProfile,
				entityInitials: excelDataParam[i]?.entityInitials,
				entityFirstName: excelDataParam[i]?.entityFirstName,
				entityMiddleName: excelDataParam[i]?.entityMiddleName,
				entityLastName: excelDataParam[i]?.entityLastName,
				entityFullName: excelDataParam[i]?.entityFullName,
				entityEmail: excelDataParam[i]?.entityEmail?.input,
				entityPhoneNumber: excelDataParam[i]?.entityPhoneNumber,
				designation: excelDataParam[i]?.designation,
				// jobBand: excelDataParam[i]?.jobBand,
				// payGrade: excelDataParam[i]?.payGrade,
				// positionCode: excelDataParam[i]?.positionCode?.input,
				entityParentCode: companyCode,
				entityCode: excelDataParam[i]?.entityEmail?.input,
			};
			// if (i === excelDataParam.length - 1) {
			//   setNavigateTo("/static/employee");
			// }
			onSubmit(payload);
			await delay(200);
		}
	};

	useEffect(() => {
		if (submitForm && submitData) {
			onSubmit(submitData);
		} else if (submitForm && submitExcelData) {
			handleExcel(submitExcelData);
		} //eslint-disable-next-line
	}, [submitForm]);

	const handleModalSubmit = (data) => {
		setSubmitData(data);
		setShowModal(true);
		if (userInfo) {
			setModalInfo({
				head: 'HR Master',
				action: 'update',
			});
		} else {
			setModalInfo({
				head: 'HR Master',
				action: 'submit',
			});
		}
	};

	const childrenOne = (
		<Form
			form={form}
			id="coe-hrorgstructure"
			layout="vertical"
			requiredMark={false}
			style={{ margin: '15px' }}
			onFieldsChange={(e) => {
				if (e[0]?.name[0] === 'positionCode') {
					if (userInfo) {
						if (e[0]?.value !== userInfo?.positionCode) {
							setCounter({
								...counter,
								position: 1,
							});
						} else {
							setCounter({
								...counter,
								position: 0,
							});
						}
					} else {
						if (e[0]?.value !== undefined) {
							setCounter({
								...counter,
								position: 1,
							});
						} else {
							setCounter({
								...counter,
								position: 0,
							});
						}
					}
				} else if (e[0]?.name[0] === 'entityInitials') {
					if (userInfo) {
						if (e[0]?.value !== userInfo?.entityInitials) {
							setCounter({
								...counter,
								initial: 1,
							});
						} else {
							setCounter({
								...counter,
								initial: 0,
							});
						}
					} else {
						if (e[0]?.value !== undefined) {
							setCounter({
								...counter,
								initial: 1,
							});
						} else {
							setCounter({
								...counter,
								initial: 0,
							});
						}
					}
				}
			}}
			onFinish={handleModalSubmit}
		>
			<Form.Item name="id" hidden={true}>
				<Input />
			</Form.Item>
			<Form.Item autoComplete="off" style={{ height: '102px' }}>
				<COEPictureUploader
					fileList={fileList}
					setFileList={setFileList}
					setImageBase64={setImageBase64}
					setCounter={setCounter}
					counter={counter}
				/>
			</Form.Item>
			<Row gutter={[16, 0]}>
				<Col xs={24} sm={8} md={8} xl={8}>
					<Form.Item
						htmlFor="entityInitials"
						label="Initial"
						name="entityInitials"
						rules={[
							{
								required: true,
								message: 'Initial is required.',
							},
						]}
					>
						<Select
							// onChange={handleActivateSubmit}
							showSearch
							allowClear
							style={{ width: '100%' }}
							filterOption={true}
							placeholder="Select from the list"
							optionFilterProp="children"
							autoComplete="off"
						>
							{initialOptions.map((value, index) => (
								<Select.Option key={index} id={value?.code} value={value?.value}>
									{value.label}
								</Select.Option>
							))}
						</Select>
					</Form.Item>
				</Col>
			</Row>

			<Row gutter={[16, 8]}>
				{/* <Col xs={24} sm={24} md={24} xl={24}>
          Name
        </Col> */}
				<Col xs={24} sm={8} md={8} xl={8}>
					<Form.Item
						label="First Name"
						htmlFor="entityFirstName"
						name="entityFirstName"
						rules={[
							{
								required: true,
								validator: validateInput,
							},
						]}
						autoComplete="off"
					>
						<Input onChange={handleActivateSubmit} id="entityFirstName" placeholder="Enter first name" autoComplete="off" />
					</Form.Item>
				</Col>

				<Col xs={24} sm={8} md={8} xl={8}>
					<Form.Item
						label="Middle Name"
						htmlFor="entityMiddleName"
						name="entityMiddleName"
						rules={[
							{
								// required: true,
								// validator: validateInput,
							},
						]}
						autoComplete="off"
					>
						<Input onChange={handleActivateSubmit} id="entityMiddleName" placeholder="Enter middle name" autoComplete="off" />
					</Form.Item>
				</Col>
				<Col xs={24} sm={8} md={8} xl={8}>
					<Form.Item
						label="Last Name"
						htmlFor="entityLastName"
						name="entityLastName"
						rules={[
							{
								required: true,
								validator: validateInput,
							},
						]}
						autoComplete="off"
					>
						<Input onChange={handleActivateSubmit} id="entityLastName" placeholder="Enter last name" autoComplete="off" />
					</Form.Item>
				</Col>
			</Row>

			<Row gutter={[16, 0]}>
				<Col xs={24} sm={12} md={12} xl={12}>
					<Form.Item
						htmlFor="entityEmail"
						label="Email"
						name="entityEmail"
						rules={[
							{
								required: true,
								type: 'email',
								validator: validateInput,
							},
						]}
						autoComplete="off"
					>
						<Input
							onChange={handleActivateSubmit}
							id="entityEmail"
							placeholder="Enter email address"
							autoComplete="off"
							disabled={userInfo?.entityStatus === 'Onboarded'}
						/>
					</Form.Item>
				</Col>
				<Col xs={24} sm={12} md={12} xl={12}>
					<Form.Item
						htmlFor="entityPhoneNumber"
						label="Mobile"
						name="entityPhoneNumber"
						rules={[
							{
								validator: (_, value) => {
									if (!value) {
										return Promise.reject('Mobile number is required.');
									} else if (/^[0-9]\d{1,14}$/.test(value)) {
										return Promise.resolve();
									} else {
										return Promise.reject('Invalid mobile number');
									}
								},
							},
						]}
						autoComplete="off"
					>
						<Input
							onChange={handleActivateSubmit}
							id="entityPhoneNumber"
							placeholder="Enter phone number (+880-XXXXXXXXXX)"
							autoComplete="off"
						/>
					</Form.Item>
				</Col>
			</Row>

			<Row gutter={[16, 8]}>
				<Col xs={24} sm={12} md={12} xl={12}>
					<Form.Item
						htmlFor="positionCode"
						label="Position ID - Name"
						name="positionCode"
						rules={[
							{
								// required: true,
								// message: "Position ID is required.",
							},
						]}
					>
						<Select
							// onChange={handleActivateSubmit}
							showSearch
							id="positionCode"
							allowClear
							style={{ width: '100%' }}
							filterOption={true}
							placeholder="Select from the List"
							optionFilterProp="children"
							autoComplete="off"
							onChange={(value) => {
								if (value) {
									form.setFieldValue('designation', positionNameMap[value][0]?.positionName);
								} else {
									form.setFieldValue('designation', '');
								}
							}}
						>
							{positionOptions.map((value, index) => (
								<Select.Option key={index} id={value?.code} value={value?.value}>
									{/* {value.label === "" ? "-" : `${value.label} - ${value?.displayName}`} */}
									{value.label === '' ? '-' : `${value?.displayName} - ${value.label}`}
								</Select.Option>
							))}
						</Select>
					</Form.Item>
				</Col>
				<Col xs={24} sm={12} md={12} xl={12}>
					<Form.Item
						htmlFor="designation"
						label="Designation"
						name="designation"
						// rules={[
						//   {
						//     required: true,
						//     validator: validateInput,
						//   },
						// ]}
						autoComplete="off"
					>
						<Input onChange={handleActivateSubmit} disabled id="designation" placeholder="To be system generated" autoComplete="off" />
					</Form.Item>
				</Col>
				<Col xs={24} sm={12} md={12} xl={12}>
					<Form.Item
						htmlFor="jobBand"
						label="Job Band"
						name="jobBand"
						rules={[
							{
								required: true,
								validator: validateInput,
							},
						]}
						autoComplete="off"
					>
						<Input onChange={handleActivateSubmit} id="jobBand" placeholder="Select from the List" autoComplete="off" />
					</Form.Item>
				</Col>
				<Col xs={24} sm={12} md={12} xl={12}>
					<Form.Item
						htmlFor="payGrade"
						label="Pay Grade"
						name="payGrade"
						rules={[
							{
								required: true,
								validator: validateInput,
							},
						]}
						autoComplete="off"
					>
						<Input onChange={handleActivateSubmit} id="payGrade" placeholder="Select from the List" autoComplete="off" />
					</Form.Item>
				</Col>
			</Row>

			<Row gutter={[16, 8]}>
				<Col xs={24}>
					<Form.Item
						htmlFor="employeeId"
						label="Employee Id"
						name="employeeId"
						// rules={[
						//   {
						//     required: true,
						//     validator: validateInput,
						//   },
						// ]}
						autoComplete="off"
					>
						<Input onChange={handleActivateSubmit} disabled id="employeeId" placeholder="To be system generated" autoComplete="off" />
					</Form.Item>
				</Col>
			</Row>

			<Flex style={{ marginTop: '10px' }} justify="flex-end" align="flex-end">
				<Button
					disabled={activate}
					style={{
						backgroundColor: activate ? '' : theme.palette.lynTheme.submit,
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						gap: '8px',
					}}
					type="primary"
					htmlType="submit"
				>
					{isLoading && !isSuccess ? <CircularProgress size={16} sx={{ color: 'white' }} /> : null} {userInfo?.id ? 'Update' : 'Submit'}
				</Button>
			</Flex>
		</Form>
	);

	const items = [
		{
			key: '1',
			label: 'Single Entry',
			children: childrenOne,
		},
		{
			key: '2',
			label: 'Bulk Entry',
			children: (
				<EmployeeExcelUpload
					employeeTableList={employeeTableList}
					setShowModal={setShowModal}
					setSubmitExcelData={setSubmitExcelData}
					setModalInfo={setModalInfo}
				/>
			),
		},
		{
			key: '3',
			label: 'Bulk Update',
			children: (
				<EmployeeBulkUpdate
					employeeTableList={employeeTableList}
					setShowModal={setShowModal}
					setSubmitExcelData={setSubmitExcelData}
					setModalInfo={setModalInfo}
					existingEmployeeIdDataMap={existingEmployeeIdDataMap}
				/>
			),
		},
	];

	return (
		<Grid container rowSpacing={4.5} columnSpacing={2.75}>
			<Grid item xs={12}>
				<DetailPageHeader title={userInfo?.id ? 'Edit Employee' : 'Create Employee'} />

				{userInfo ? (
					<MainCard>{childrenOne}</MainCard>
				) : (
					<MainCard>
						<Tabs defaultActiveKey="1" items={items} type="card" />
					</MainCard>
				)}
				{showModal && (
					<ComptrollerConfirmModal showModal={showModal} setShowModal={setShowModal} setSubmitForm={setSubmitForm} modalData={modalInfo} />
				)}
			</Grid>
		</Grid>
	);
};

export default COEEmployee;
